module.exports = __webpack_public_path__ + "img/Thumbnail_live.3e75a5ed.png";